import React, { useState } from 'react';
import withSearch from '../../hoc/withSearch';
import Filters from '../../components/filters';
import SearchResult from '../../components/search-result';

const Search = (props) => {
    const [isTableView, setTableView] = useState(false);
    const [isMapView, setMapView] = useState(false);

    return (
        <>
            <Filters isTableView={isTableView} 
                     setTableView={setTableView} 
                     isMapView={isMapView}
                     setMapView={setMapView} 
                     submitForm={props.submitForm}
                     form={props.form}
                     search={props.search} 
                     useTurnover={true} 
                     useTurnoverMeal={true}
                     useType={true}
                     useRegion={true}
                     useChainname={true}
                     useWholesalename={true}
                     useAssortment={true} 
                     useOtherInfo={true}
                     useControls={true} />
            <SearchResult search={props.search}
                          isTableView={isTableView} 
                          isMapView={isMapView} 
                          location={props.locationHandler}
                          setMapView={setMapView} 
                          fetch={props.fetch} 
                          roles={props.roles} />
        </>
    );
};

export default withSearch(Search);